import { message } from "antd";

/**
 * Copies the Ollie ID of a plan review project to the clipboard and shows the result to the user.
 * The browser can block the clipboard (for example on a page that is not served over HTTPS),
 * so a failure shows an error message instead of failing silently.
 */
export const copyOllieIdToClipboard = async (ollieId: string) => {
	try {
		if (!navigator.clipboard) {
			message.error("Your browser does not allow copying. Please select the Ollie ID and copy it by hand.");
			return;
		}

		await navigator.clipboard.writeText(ollieId);
		message.success("Ollie ID copied to clipboard");
	} catch (error) {
		console.error(`[PlanReview] copyOllieIdToClipboard: could not copy ${ollieId}`, error);
		message.error("We couldn't copy the Ollie ID. Please select it and copy it by hand.");
	}
};
